<template>
	<div class="item-container">
		<div class="messages">
			<div
				v-for="(message, j) in messages"
				:key="'forced-message--' + j"
				:style="{'animation-delay': (j + 's')}"
				class="message"
			>
				<span v-html="message"/>
			</div>
		</div>
		<div
			class="item-edit"
			:style="{'animation-delay': messages.length + 's'}"
		>
			<template v-if="typeIsPreExperience">
				<b-row align-v="center" class="mb-4">
					<b-col md="4">
						<Avatar :avatar="avatarCatNotebook" fluid />
					</b-col>
				</b-row>
			</template>
		</div>
	</div>
</template>

<script>
import Avatar, {CAT_NOTEBOOK} from "@/vue/common/image/Avatar.vue";

export const TYPE__PRE_EXPERIENCE = 'pre-experience';

const MESSAGES = {
	[TYPE__PRE_EXPERIENCE]: [
		'Gratuliere!',
		'Dein <b>Stellenprofil</b> ist nun anonymisiert veröffentlicht und kann von Kandidaten gefunden werden!',
		'Um den Job für Bewerber interessant zu machen und das Matching zu verbessern, gib bitte noch ein paar mehr Informationen ein.'
	],
};

export default {
	components: {Avatar},

	props: {
		type: {
			type: String,
			required: true,
		}
	},

	computed: {
		messages ()
		{
			return MESSAGES[this.type];
		},
		typeIsPreExperience ()
		{
			return this.type === TYPE__PRE_EXPERIENCE;
		},
		avatarCatNotebook ()
		{
			return CAT_NOTEBOOK;
		}
	}
}
</script>
